import { JOB_LOCATION_TYPE, JOBS_BOARD_TYPES, PRIOR_EXPERIENCE_NEEDED } from '../constants.js'

export default {
  boardType: Object.values(JOBS_BOARD_TYPES),
  priorExperienceNeeded: Object.values(PRIOR_EXPERIENCE_NEEDED),
  requiredLicenseType: ['CDL Class A', 'CDL Class B'],
  endorsementsDoublesOrTriples: ['Required', 'Preferred', 'Not needed'],
  endorsementsTanker: ['Required', 'Preferred', 'Not needed'],
  endorsementsHazardousMaterials: ['Required', 'Preferred', 'Not needed'],
  jobLocationType: Object.values(JOB_LOCATION_TYPE),
  payType: [
    'Dollar',
    'Cents'
  ],
  timeType: [
    'Days',
    'Weeks',
    'Months',
    'Years'
  ],
  workDays: [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ],
  workHours: [
    'Days',
    'Swing',
    'Graveyard'
  ],
  physicalRequirements: [
    'Light',
    'Moderate',
    'High'
  ],
  payStructure: [
    'Hourly',
    'Mileage',
    'PercentageOfLoad'
  ],
  states: [
    { name: 'Alabama', abr: 'AL' },
    { name: 'Alaska', abr: 'AK' },
    { name: 'Arizona', abr: 'AZ' },
    { name: 'Arkansas', abr: 'AR' },
    { name: 'California', abr: 'CA' },
    { name: 'Colorado', abr: 'CO' },
    { name: 'Connecticut', abr: 'CT' },
    { name: 'Delaware', abr: 'DE' },
    { name: 'District of Columbia', abr: 'DC' },
    { name: 'Florida', abr: 'FL' },
    { name: 'Georgia', abr: 'GA' },
    { name: 'Hawaii', abr: 'HI' },
    { name: 'Idaho', abr: 'ID' },
    { name: 'Illinois', abr: 'IL' },
    { name: 'Indiana', abr: 'IN' },
    { name: 'Iowa', abr: 'IA' },
    { name: 'Kansas', abr: 'KS' },
    { name: 'Kentucky', abr: 'KY' },
    { name: 'Louisiana', abr: 'LA' },
    { name: 'Maine', abr: 'ME' },
    { name: 'Maryland', abr: 'MD' },
    { name: 'Massachusetts', abr: 'MA' },
    { name: 'Michigan', abr: 'MI' },
    { name: 'Minnesota', abr: 'MN' },
    { name: 'Mississippi', abr: 'MS' },
    { name: 'Missouri', abr: 'MO' },
    { name: 'Montana', abr: 'MT' },
    { name: 'Nebraska', abr: 'NE' },
    { name: 'Nevada', abr: 'NV' },
    { name: 'New Hampshire', abr: 'NH' },
    { name: 'New Jersey', abr: 'NJ' },
    { name: 'New Mexico', abr: 'NM' },
    { name: 'New York', abr: 'NY' },
    { name: 'North Carolina', abr: 'NC' },
    { name: 'North Dakota', abr: 'ND' },
    { name: 'Ohio', abr: 'OH' },
    { name: 'Oklahoma', abr: 'OK' },
    { name: 'Oregon', abr: 'OR' },
    { name: 'Pennsylvania', abr: 'PA' },
    { name: 'Rhode Island', abr: 'RI' },
    { name: 'South Carolina', abr: 'SC' },
    { name: 'South Dakota', abr: 'SD' },
    { name: 'Tennessee', abr: 'TN' },
    { name: 'Texas', abr: 'TX' },
    { name: 'Utah', abr: 'UT' },
    { name: 'Vermont', abr: 'VT' },
    { name: 'Virginia', abr: 'VA' },
    { name: 'Washington', abr: 'WA' },
    { name: 'West Virginia', abr: 'WV' },
    { name: 'Wisconsin', abr: 'WI' },
    { name: 'Wyoming', abr: 'WY' },
    { name: 'Canada', abr: 'CAN' },
    { name: 'Mexico', abr: 'MEX' }
  ],
  positionLocal: [
    'Pickup & Delivery',
    'Intermodal/Containers',
    'Tanker',
    'Tanker/Hazmat',
    'Hazmat (non-tanker)',
    'Log Truck',
    'Chip Truck',
    'Heavy Haul/Oversized',
    'Dump Truck',
    'Cement Truck',
    'Shuttle Driver',
    'Garbage Truck',
    'Equipment Delivery',
    'Dry Bulk',
    'Oil Field Driver',
    'Hostler',
    'Hot Shot',
    'LTL City Pick-up and Delivery',
    'Van',
    'Other'
  ],
  positionRegional: [
    'Intermodal/Containers',
    'Tanker',
    'Tanker/Hazmat',
    'Hazmat (non-tanker)',
    'Log Truck',
    'Chip Truck',
    'Heavy Haul/Oversized',
    'Dump Truck',
    'Cement Truck',
    'Refrigerated',
    'Van',
    'Doubles',
    'Triples',
    'Flatbed',
    'Roll Top',
    'Curtain Van',
    'Car Carrier',
    'Livestock',
    'Drop Deck',
    'Dry Bulk',
    'Household Goods',
    'Oil Field Driver',
    'Hot Shot',
    'Other'
  ],
  positionOTR: [
    'Tanker',
    'Tanker/Hazmat',
    'Hazmat (non-tanker)',
    'Heavy Haul/Oversized',
    'Van',
    'Doubles',
    'Triples',
    'Refrigerated',
    'Flatbed',
    'Roll Top',
    'Curtain Van',
    'Car Carrier',
    'Livestock',
    'Drop Deck',
    'Dry Bulk',
    'Household Goods',
    'Oil Field Driver',
    'Hot Shot',
    'Other'
  ],
  positionTeamDriving: [
    'Tanker',
    'Tanker/Hazmat',
    'Hazmat (non-tanker)',
    'Heavy Haul/Oversized',
    'Van',
    'Doubles',
    'Triples',
    'Refrigerated',
    'Flatbed',
    'Roll Top',
    'Curtain Van',
    'Car Carrier',
    'Livestock',
    'Drop Deck',
    'Dry Bulk',
    'Household Goods',
    'Oil Field Driver',
    'Hot Shot',
    'Other'
  ]
}
